import { render } from "./BookEvent.vue?vue&type=template&id=7c074d44"
import script from "./BookEvent.vue?vue&type=script&lang=js"
export * from "./BookEvent.vue?vue&type=script&lang=js"

import "./BookEvent.vue?vue&type=style&index=0&id=7c074d44&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__